module.exports = __webpack_public_path__ + "static/media/art15.ef0246b7.jpg";